<template>
  <div>
    <MainForm
      :show-step="isOnStep"
      :logic-callbacks="getLogicCallback"
      :ui-form="uiForm"
      name="nbc-loan-form"
      :end-page-data="endPageData"
      :ui-modal-and-end-page="uiModalAndEndPage"
      ui-title="NBC Top Up application"
      :data-nbc-suggestions-visible="showFilters"
      :data-nbc-finished="hasNBCFinished"
    >
      <!-- <div v-if="isSalesAgent">
        <StepOtp :change-phone-action="gotToWelcome" />
      </div> -->
 <StepContact :validateFn="validateCustmerContact" />
      <StepModel
        :ui="uiBaseStep"
        name="use-step"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
        ui-hide-button
        :custom-flow="[
          {
            condition: () => fieldValues(FIELD_NAMES.use) === 'Other',
            goTo: 'other-step',
          },
          {
            condition: () => fieldValues(FIELD_NAMES.use) !== 'Other',
            goTo: 'howmuch-step',
          }
        ]"
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="use"
          ui-title="What are you going to use the loan for?"
        >
          <UiWrapper :name="FIELD_NAMES.use" next-step-on-change>
            <Choice :columns="3" :options="USE" />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>

      <StepModel
        :ui="uiBaseStep"
        name="other-step"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="other"
          ui-title="What are you going to use the loan for?"
        >
          <UiWrapper :name="FIELD_NAMES.other" label="e.g. to study">
            <InputText />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>

      <StepModel
        :ui="uiBaseStep"
        name="howmuch-step"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
      >
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="howmuch"
          ui-title="How much do you need to borrow?"
        >
          <FieldIncome :name="FIELD_NAMES.howmuch" label="Enter any amount, in AED (e.g. 5000)" />
        </FieldsetModel>
      </StepModel>

      <StepModel
        :ui="uiBaseNbc"
        name="instalments-step"
        ui-title=" "
        ui-subtitle=" "
        ui-error-message="Please review the fields marked in red"
        ui-button-text="Apply"
      >
        <!-- :actionHandler="actionWrapper(goToForm, product.onboarding_form)" -->
        <FieldsetModel
          :ui="uiBaseFieldset"
          name="instalments"
          ui-title="In how many instalments would you like to repay?"
        >
          <UiWrapper :ui="uiBaseField" :name="FIELD_NAMES.instalments" :default-value="4">
            <InputSlide
              :min="1"
              :max="4"
              :suffix="suffixSingularPlural(FIELD_NAMES.instalments, ' year')"
            />
          </UiWrapper>
        </FieldsetModel>
      </StepModel>
    </MainForm>
  </div>
</template>

<script>
let stepToGo = "Welcome";
// Services
import flowManager from "@/lib/services/flow-manager";
import store from "@/store";
// Models
import MainForm from "@/lib/components/main-form";
import StepModel from "@/lib/components/models/step";
import FieldsetModel from "@/lib/components/models/fieldset";
import StepOtp from "@/forms/components/shared/steps/otp";
import StepContact from "@/forms/components/shared/steps/contact-verification";
import FIELD_NAMES from "@/forms/constants/field-names";
import {
  SET_USE,
  SET_HOW_MUCH,
  SET_INSTALMENT,
  SET_OTHER,
  SET_LOAN_TYPE,
   SET_CUSTOMER_CONSENT,
} from "@/lib/constants/mutations";
// Ui Wrappers
import UiWrapper from "@/forms/components/base/ui-wrapper";
import FieldIncome from "@/forms/components/shared/fields/income";
import otpServiceReferal from "@/forms/api/services/otp-referral";
import sleep from '@/forms/helpers/sleep';
// Ui Components
import {
  NBCSuggestions,
  InputText,
  Choice,
  InputSlide,
  Button,
  ProductCover,
  SidePanel,
  Grid,
  PlainText
} from "@dunia/ui";

// Utils
import getValueByFieldName from "@/forms/helpers/get-value-by-field-name";
import FormComponentMixin from "@/lib/mixins/form-component-mixin";
//import getGoogleTagManager from "@/forms/helpers/google-tag-manager";
// Helpers

// Constants
import {
  SPENDING,
  YESNO,
  REWARDSTYPE,
  USE,
  FEATURES_LOAN,

  //FIELD_NAMES
} from "@/forms/constants/nbc-logic";

export default {
  name: "NBC",

  mixins: [FormComponentMixin],

  components: {
    NBCSuggestions,
    // Components
    MainForm,
    StepModel,
    FieldsetModel,
    InputText,
    Choice,
    InputSlide,
    UiWrapper,
    FieldIncome,
    Button,
    // Pages
    ProductCover,
    SidePanel,
    Grid,
    PlainText,
    StepOtp,
    StepContact
  },

  data: () => ({
    panelVisible: -1,
    SPENDING,
    YESNO,
    REWARDSTYPE,
    USE,
    FEATURES_LOAN,
    FIELD_NAMES
  }),
  mounted() {
    //getGoogleTagManager();
    var gtagID = process.env.VUE_APP_GA_MEASUREMENT_ID;
    if (gtagID) {
      (function(w, d, s, l, i) {
        w[l] = w[l] || [];
        w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
        var f = d.getElementsByTagName(s)[0],
          j = d.createElement(s),
          dl = l != "dataLayer" ? "&l=" + l : "";
        j.async = true;
        j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
        f.parentNode.insertBefore(j, f);
      })(window, document, "script", "dataLayer", `${gtagID}`);
    }
  },
  updated: function() {
    store.commit(SET_USE, { use: this.fieldValues(FIELD_NAMES.use) });
    store.commit(SET_HOW_MUCH, {
      howMuch: this.fieldValues(FIELD_NAMES.howmuch)
    });
    store.commit(SET_INSTALMENT, {
      instalment: this.fieldValues(FIELD_NAMES.instalments)
    });
    store.commit(SET_OTHER, { other: this.fieldValues(FIELD_NAMES.other) });
    store.commit(SET_LOAN_TYPE, { loanType: "Personal Loan" });
  },
  computed: {
    // show if
    // - already in installments step
    showFilters() {
      const sn = flowManager.currentStepName;
      return sn === "instalments-step" || sn === "show-cards";
    },

    getFilteredSuggestions() {
      return FEATURES_LOAN;
    },

    dynamicRecommendation() {
      const { values } = this.$store.state.formData;

      const use = getValueByFieldName(values, FIELD_NAMES.use);
      const other = getValueByFieldName(values, FIELD_NAMES.other);
      const howmuch = getValueByFieldName(values, FIELD_NAMES.howmuch);
      const instalments = getValueByFieldName(values, FIELD_NAMES.instalments);

      const r1 = "A <strong>loan</strong>";
      let r2 = "";
      let r3 = "";
      let r4 = "";

      if (use === "BH") {
        r2 = " to <strong>buy a house</strong>";
      }
      if (use === "BC") {
        r2 = " to <strong>start/run my business</strong>";
      }
      if (use === "ME") {
        r2 = " for a <strong>medical emergency</strong>";
      }
      if (use === "GH") {
        r2 = " to <strong>go on holidays</strong>";
      }
      if (use === "EC") {
        r2 = " to <strong>educate my children</strong>";
      }
      if (use === "SF") {
        r2 = " to <strong>support my family</strong>";
      }
      if (use === "SMF") {
        r2 = " to <strong>send money to family</strong>";
      }
      if (use === "O") {
        r2 = ` for <strong>${other}</strong>`;
      }

      if (howmuch !== null) {
        r3 = ` of <strong>${howmuch} AED</strong>`;
      }

      if (howmuch !== null && instalments !== null) {
        r4 = ` in <strong>${instalments} years</strong>`;
      }

      return `${r1}${r2}${r3}${r4}`;
    },

    hasNBCFinished() {
      return flowManager.currentStepName === "show-cards";
    },
    isSalesAgent() {
      return (
        this.$store.state.employeeCodes && this.$store.state.channel != "DSA"
      );
    }
  },

  methods: {
    actionWrapper(cb, ...args) {
      return () => cb(...args);
    },

    calculatedLoanOffer(title, interest) {
      const amountToBorrow = this.fieldValues(FIELD_NAMES.howmuch);
      const amountOfInstalments = this.fieldValues(FIELD_NAMES.instalments);
      const amountWithInterest =
        amountToBorrow + amountToBorrow * (interest / 100);
      const monthlyLoan = amountWithInterest / (amountOfInstalments * 12);
      const AMOUNT = monthlyLoan.toFixed(2);

      return `${title} ${AMOUNT} AED / month`;
    },

    fieldValues(fieldname) {
      const { $store } = this;

      return getValueByFieldName($store.state.formData.values, fieldname);
    },

    // benefits panel logic
    isPanelVisible(key) {
      return key === this.panelVisible;
    },

    showPanel(key) {
      this.panelVisible = key;
    },

    hidePanel() {
      this.panelVisible = -1;
    },

    showBest(key, label) {
      if (key === 0) {
        return label;
      }
      return null;
    },

    gotToWelcome(callback) {
      var product = this.fieldValues(FIELD_NAMES.product);
      var formToGo = "";
      // if (product) {
      //   if (product.toLowerCase() === "personal loan".toLowerCase()) {
      //     formToGo = "Deem | Loan Application";
      // } else if (product.toLowerCase() === "credit card") {
      formToGo = "STP Loan";
      //}
      // }
      callback();
      if (formToGo != "") {
        router.goToFormByName(formToGo, {
          stepNameToInit: stepToGo
        });
      }
    },
    async validateCustmerContact() {
      const spinner = document.getElementById("spinner");
      var currentStep = this.STEP_NAMES.contactCodeVerification;
      spinner.removeAttribute("hidden");
      var consent = await otpServiceReferal.validateAndBlockCustomerConsent(
        currentStep,
        this
      );

      store.commit(SET_CUSTOMER_CONSENT, { customerConsent: consent });

      if (consent) {
        document.getElementById("firstSpan").style.display = "none";
        document.getElementById("linkButton").style.display = "none";
          document.getElementById("thirdSpan").style.display = "none";
        document.getElementById("secondSpan").innerHTML =
          "Customer application has been verified successfully.";
         await sleep(2000);
        spinner.setAttribute("hidden", "");
         flowManager.goToNextStep({stepToGo : 'use-step', skipValidations: true });
      } else {
        document.getElementById("firstSpan").style.display = "none";
         document.getElementById("thirdSpan").style.display = "none";
        document.getElementById("secondSpan").innerHTML =
          "It seems the customer has not verifed his application through the link, which has been sent to his mobile number. To check again click ";
        spinner.setAttribute("hidden", "");
      }
      spinner.setAttribute("hidden", "");
    },

  }
};
</script>
